import { getRuntimeConfig } from '@gto/helpers/runtime-env'

/**
 * Get the API base URL based on the current runtime environment.
 * This is computed at runtime from the origin URL, not from build-time env vars.
 */
export function getApiBaseUrl(): string {
  return getRuntimeConfig().apiBaseUrl
}
